export const GET_DEALS_LISTING = "GET_DEALS_LISTING";
export const GET_DEALS_DETAIL = "GET_DEALS_DETAIL";
export const GET_DEALS_FORM_DATA = "GET_DEALS_FORM_DATA";
export const GET_ESTIMATE_FORM_DATA = "GET_ESTIMATE_FORM_DATA";
export const GET_PROPOSAL_BY_ID = "GET_PROPOSAL_BY_ID";
export const GET_PROPOSAL_DETAIL_BY_ID = "GET_PROPOSAL_DETAIL_BY_ID";
export const GET_PROPOSAL_BUILDER = "GET_PROPOSAL_BUILDER";
